import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Logout from './components/Logout'

import routes from './core/constants/routes'
import {
	LoginContainer,
	SignUpContainer,
	SignUpUserContainer,
	VerifyContainer,
	EstimatesContainer,
	EstimatesDetailContainer,
	InvoicesContainer,
	InvoiceDetailContainer,
	WorkOrderDetailContainer,
	AccountSettingContainer,
	NotFoundPage,
	ForgotPasswordContainer,
	ResetPasswordContainer,
	ManageUsersContainer,
	WorkFlowContainer,
	AdasReportsContainer,
	AdasReportDetailContainer
} from './containers'
import useAppContext from './components/app'
const {
	LOGIN,
	SIGNUP,
	SIGNUPUSER,
	VERIFY,
	INVOICES,
	INVOICEDETAIL,
	ESTIMATES,
	ESTIMATESDETAIL,
	WORKORDERDETAIL,
	ACCOUNTSETTING,
	FORGOTPASSWORD,
	RESETPASSWORD,
	MANAGEUSERS,
	WORKFLOW,
	ADAS_REPORTS,
	ADAS_REPORT_DETAIL
} = routes

const PrivateRoute = ({ component: Component, isShare = false, ...rest }) => {
	const { store: { clientPortalUser } } = useAppContext()
	return (
		<Route
			{...rest}
			render={props => {
				if (!localStorage.access_token) return <Logout />
				if (!clientPortalUser && !isShare)return <Logout />
				return <Component {...props} />
			}}
		/>
	)
}

const App = () => {
	const { store: { clientPortalUser, clientSettings } } = useAppContext()
	// ADAS Reports are gated per-client by the allowView toggle. When it's off,
	// the nav entry is hidden and direct URL access redirects to Invoices.
	const canViewAdas = !!(clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.allowView)
	return (
		<Switch>
			<Redirect exact path='/' to={INVOICES} />
			<Route exact path={LOGIN} component={LoginContainer} />
			<Route exact path={SIGNUP} component={SignUpContainer} />
			<Route exact path={SIGNUPUSER} component={SignUpUserContainer} />
			<Route exact path={FORGOTPASSWORD} component={ForgotPasswordContainer} />
			<Route exact path={RESETPASSWORD} component={ResetPasswordContainer} />
	 		<Route exact path={VERIFY} component={VerifyContainer} />
			<PrivateRoute exact path={ACCOUNTSETTING} component={AccountSettingContainer} />
			<PrivateRoute exact path={ESTIMATES} component={EstimatesContainer} state={{ from: ESTIMATES }} />
			<PrivateRoute exact path={ESTIMATESDETAIL} component={EstimatesDetailContainer} isShare />
			<PrivateRoute exact path={INVOICES} component={InvoicesContainer} />
			<PrivateRoute exact path={INVOICEDETAIL} component={InvoiceDetailContainer} isShare />
			<PrivateRoute exact path={WORKORDERDETAIL} component={WorkOrderDetailContainer} isShare />
			<PrivateRoute exact path={WORKFLOW} component={WorkFlowContainer} />
			{canViewAdas ? (
				<PrivateRoute exact path={ADAS_REPORTS} component={AdasReportsContainer} />
			) : (
				<Route exact path={ADAS_REPORTS}><Redirect to={INVOICES} /></Route>
			)}
			{clientPortalUser && !canViewAdas ? (
				// A logged-in client without allowView can't open ADAS detail.
				<Route exact path={ADAS_REPORT_DETAIL}><Redirect to={INVOICES} /></Route>
			) : (
				// Share visitors (emailed link, no session) reach it via isShare; the
				// emailed token authorizes this one report and the API enforces it.
				<PrivateRoute exact path={ADAS_REPORT_DETAIL} component={AdasReportDetailContainer} isShare />
			)}
			{clientPortalUser && clientPortalUser.admin && <PrivateRoute exact path={MANAGEUSERS} component={ManageUsersContainer} />}
			<Route path='*'>
				<NotFoundPage />
			</Route>
		</Switch>
	)
}

export default App
